import { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { resources } from "@constants/hardcoded-strings";
import { ContentPageHeader } from "@containers/common/content-page-header/content-page-header";
import { CardContainer } from "@containers/common/card-container/card-container";
import { LoadingIndicator } from "@containers/common/loading-indicator/loading-indicator";
import { ContentPageBody } from "@containers/common/content-page-body/content-page-body";
import styles from "./workflow-report-container.less";
import { getReportLinkRequest } from "@requests/reports/get-report-link";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";

export const WorkflowReportContainer = () => {
    const dispatch = useDispatch();
    const [shouldLoadReportLink, setShouldLoadReportLink] = useState(true);
    const [requestInProgress, setRequestInProgress] = useState(false);
    const [embedURL, setEmbedURL] = useState(null);

    const fetchWorkflowReport = async () => {
        setRequestInProgress(true);
        const { data, error } = await getReportLinkRequest("workflow-report-v1");
        if (data?.url) {
            setEmbedURL(data.url);
        } else if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.getReportLink.error.title,
                resources.requests.getReportLink.error.message
            );
        }
        setRequestInProgress(false);
    };

    useEffect(() => {
        if (shouldLoadReportLink) {
            setShouldLoadReportLink(false);
            fetchWorkflowReport();
        }
    }, [shouldLoadReportLink]);

    const isLoading = useMemo(() => {
        return requestInProgress || shouldLoadReportLink;
    }, [requestInProgress, shouldLoadReportLink]);

    const isLoaded = useMemo(() => {
        return !!(
            !isLoading &&
            embedURL
        );
    }, [
        isLoading,
        embedURL
    ]);

    return (
        <CardContainer>
            <ContentPageHeader title={resources.pages.workflowReport.header} />
            <ContentPageBody isMaxWidth={true}>
                {isLoading && (
                    <LoadingIndicator title={resources.common.loadingIndicatorText} />
                )}
                {isLoaded && (
                    <div className={styles.workflowReportContainer}>
                        {embedURL && (
                            <div className={styles.workflowReportChartContainer}>
                                <iframe className={styles.workflowReportChartIframe} src={embedURL} />
                            </div>
                        )}
                    </div>
                )}
            </ContentPageBody>
        </CardContainer >
    );
};